/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter, useLocation } from 'react-router-dom';
import validate from 'validate.js';
import { Box, DialogContentText, Grid, Alert } from '@mui/material';
import moment from 'moment';
import UsuarioModal from './UsuarioModal';
import StatusModal from './StatusModal';
import IniciarDigitacaoModal from './IniciarDigitacaoModal';
import SimilarityModal from '../Nsirs/components/SimilarityModal';
import ExportServicosDialog from '../Nsirs/components/ExportServicosDialog';
import { EXPORT_MESSAGES } from '../Nsirs/constants';
import {
  InputV2,
  WidgetV2,
  NsirStatusSelectV2,
  NsirSyncStatusSelectV2,
  DropzoneV2,
  DialogDefaultV2,
  OptionSelectV2,
  UploadDialogV2,
  SimNaoSelectV2,
} from '../../../components/v2';
import * as Roles from '../../../constants/role';
import * as Status from '../../../constants/status';
import * as actionsNsirs from '../../../store/nsir/actions';
import * as actionsRelatorioJob from '../../../store/relatorioJob/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as actionsToast from '../../../store/toast/actions';
import { importUsoMutuo } from '../../../store/nsmp/actions';
import * as selectorsModuleConfiguration from '../../../store/moduleConfiguration/reducer';
import * as selectorsNsirs from '../../../store/nsir/reducer';
import * as selectorsAlimentador from '../../../store/alimentador/reducer';
import { NSIR_STATUS_UPDATE } from 'constants/modules';
import { hasModuleConfiguration } from '../../../helpers/moduleConfigurationPermission';
import { isInspecaoMtBt, isInspecaoAuditoriaFaixa, isUsuarioUsoMuto, isUsoMutuo, buildRequiredSchema, isTrue, isNullOrUndefined, isInspecaoFibraOpticaOuProjetoObras, tipoServicoTemSubtipo } from 'utils';
import {
  podePersistirAuditoria,
  situacaoPermiteEdicaoAuditoria,
  isRoleAuditoriaNsir
} from '../../../helpers/auditoriaNsirPermission';
import { isUsuarioSupervisor } from '../../../helpers/inspecaoReportPermission';
import {
  canShowLiberarDigitacaoAntecipada,
  canShowRevogarDigitacaoAntecipada,
  isDigitacaoAntecipadaAtiva,
} from '../../../helpers/digitacaoAntecipada';
import { buildNsirDocumentoKmzFileName } from '../../../utils/nsirDocumentoKmzName';
import InformacaoBasicaForm from './informacao-basica/InformacaoBasicaForm';
import ProjetoObrasFibraOpticaForm from './informacao-basica/ProjetoObrasFibraOpticaForm';
import UsoMutuoForm from './informacao-basica/UsoMutuoForm';
import ParseRfgPanel from './auditoria-faixa/ParseRfgPanel';
import * as actionsNsmp from '../../../store/nsmp/actions';
import * as selectorsNsmp from '../../../store/nsmp/reducer';
import * as actionsParseRfg from '../../../store/parseRfg/actions';
import * as selectorsParseRfg from '../../../store/parseRfg/reducer';
import { isRelatorioJobAvailable } from '../../../helpers/relatorioJob';
import { forgetParseRfgJobId, forgetParseRfgFreshUpload, rememberParseRfgFreshUpload, readParseRfgFreshUpload } from '../../../helpers/auditoriaFaixa';
import * as XLSX from 'xlsx';

const InformacaoBasicaTab = ({
  nsir,
  onSave,
  onHeaderFieldsChange,
  authData,
  generateNsirReportById,
  startRelatorioAuditoriaFaixa,
  updateStatus,
  iniciarDigitacaoNsir,
  trocarDigitadorNsir,
  trocarInspetorNsir,
  exportCcsm,
  messageError,
  messageWarning,
  importUsoMutuo,
  forceUpdateStatusNsir,
  moduleConfigurations,
  history,
  similarityResults,
  similarityPendingData,
  clearSimilarity,
  saveNsirForce,
  alimentadoresOptions,
  patchNsirAuditoria,
  digitacaoAntecipadaNsir,
  nsmps,
  deleteNsmp,
  cleanParseRfg,
  startParseRfg,
  parseRfgJob,
  parseRfgUploadedNsirId,
}) => {
  const [statusModal, setStatusModal] = useState(false);
  const [atualizarStatusModal, setAtualizarStatusModal] = useState({ open: false, defaultStatus: null });
  const [openCcsm, setOpenCcsm] = useState(false);
  const [openRemoverInspetor, setOpenRemoverInspetor] = useState(false);
  const [inspetorModal, setInspetorModal] = useState({ open: false, isChange: false });
  const [digitadorModal, setDigitadorModal] = useState({ open: false, isChange: false });
  const [antecipadaModal, setAntecipadaModal] = useState(false);
  const [revogarAntecipadaOpen, setRevogarAntecipadaOpen] = useState(false);
  const [iniciarDigitacaoModal, setIniciarDigitacaoModal] = useState(false);
  const [digitacaoFinalizadaError, setDigitacaoFinalizadaError] = useState({ open: false, message: '' });
  const [errors, setErrors] = useState({});
  const [documentoKmz, setDocumentoKmz] = useState(null);
  const [openImportPostes, setOpenImportPostes] = useState(false);
  const [openSimilarityModal, setOpenSimilarityModal] = useState(false);
  const [modoEdicaoAuditoriaNsir, setModoEdicaoAuditoriaNsir] = useState(false);
  const [openDowngradeNewFlow, setOpenDowngradeNewFlow] = useState(false);
  const [openExportServico, setOpenExportServico] = useState(false);
  const autoPersistNewFlowRef = useRef(null);
  const pendingRfgFileRef = useRef(null);
  const [values, setValues] = useState({
    vencimento: moment().valueOf(),
    status: 'EM_CRIACAO',
    inspecaoTermografica: false,
  });

  const location = useLocation();

  useEffect(() => {
    clearSimilarity();
  }, []);

  useEffect(() => {
    if (nsir && nsir.id) {
      const next = {
        ...nsir,
        vencimento: moment(nsir.vencimento)
          .locale('ptBR')
          .toISOString()
      };
      // Legado faixa: newFlow null/undefined → false (UI e contrato dual UI)
      if (isInspecaoAuditoriaFaixa(nsir.tipoServicoId) && !isTrue(nsir.newFlow)) {
        next.newFlow = 'false';
      }
      // Reload pós-parse não pode desfazer upgrade local se o RFG já foi enviado nesta sessão
      setValues((prev) => {
        const keepUpgrade =
          isInspecaoAuditoriaFaixa(nsir.tipoServicoId)
          && isTrue(prev.newFlow)
          && !isTrue(nsir.newFlow)
          && (parseRfgUploadedNsirId === nsir.id || readParseRfgFreshUpload(nsir.id));
        if (keepUpgrade) {
          return { ...next, newFlow: 'true' };
        }
        return next;
      });
      if (nsir.documentoKmzFile) {
        setDocumentoKmz(nsir.documentoKmzFile);
      }
    }
  }, [nsir, parseRfgUploadedNsirId]);

  useEffect(() => {
    if (nsir && !nsir.id && Array.isArray(similarityResults) && similarityResults.length > 0) {
      setOpenSimilarityModal(true);
    } else {
      setOpenSimilarityModal(false);
    }
  }, [nsir, similarityResults]);

  useEffect(() => {
    if (!situacaoPermiteEdicaoAuditoria(values.status)) {
      setModoEdicaoAuditoriaNsir(false);
    }
  }, [values.status]);

  const onHeaderFieldsChangeRef = useRef(onHeaderFieldsChange);
  onHeaderFieldsChangeRef.current = onHeaderFieldsChange;

  useEffect(() => {
    onHeaderFieldsChangeRef.current?.({
      codigo: values.codigo || '',
      equipamento: values.equipamento || '',
    });
  }, [values.codigo, values.equipamento]);

  const handleChange = event => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };

  const canAtualizarStatus = () =>
    hasModuleConfiguration(moduleConfigurations, authData, NSIR_STATUS_UPDATE);

  const isDigitador = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.DIGITADOR && values.status === Status.EM_DIGITACAO && values.digitadorId === authData.id;
  const isInspetor = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.INSPETOR;
  const isAdmin = () => !isUsuarioUsoMuto(authData.email) && authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);
  const podeEditarAuditoriaNsir = () => {
    if (isUsuarioUsoMuto(authData.email) || !authData) return false;
    return podePersistirAuditoria({
      role: authData.role,
      nsirStatus: values.status,
      modoEdicaoAuditoria: modoEdicaoAuditoriaNsir
    });
  };
  const usuarioCroquiPodeEditar = () => !isUsuarioUsoMuto(authData.email) && authData && authData.role === Roles.CROQUI && (values.status === Status.EM_CRIACAO || values.status === Status.AGUARDANDO_INSPECAO);
  const canRemoverInspetor = () =>
    !!values.id &&
    !!values.inspetorId &&
    values.status !== Status.EXECUTADA_GDIS &&
    values.status !== Status.FINALIZADA &&
    values.status !== Status.CANCELADA &&
    isUsuarioSupervisor(authData) &&
    !isUsuarioUsoMuto(authData.email);

  const getActions = () => {
    const errors = validate(nsir, getSchema(nsir));
    const isValid = errors === undefined || (errors && Object.keys(errors).length === 0 && errors.constructor === Object);

    const actions = [
      {
        onClick: () => setOpenImportPostes(true),
        title: 'Adicionar Postes',
        show: values.id !== undefined && (values.status === Status.EM_CRIACAO || values.status === Status.AGUARDANDO_INSPECAO) && isAdmin() && isValid && isUsoMutuo(values.tipoServicoId)
      },
      {
        onClick: () => setAtualizarStatusModal({ open: true, defaultStatus: values.status }),
        title: 'Atualizar Status',
        show: !!values.id && canAtualizarStatus()
      },
      {
        onClick: () => setInspetorModal({ open: true, isChange: false }),
        title: 'Publicar para Inspeção',
        show: values.id !== undefined && values.status === Status.EM_CRIACAO && isAdmin() && isValid
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.EM_INSPECAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Iniciar Inspeção',
        show:
          values.status === Status.AGUARDANDO_INSPECAO &&
          values.inspetorId === authData.id
      },
      {
        onClick: () => setInspetorModal({ open: true, isChange: true }),
        title: 'Trocar Inspetor',
        show: (values.status === Status.AGUARDANDO_INSPECAO || values.status === Status.INSPECAO_ENVIADA_PARCIAL) && isAdmin()
      },
      {
        onClick: () => setOpenRemoverInspetor(true),
        title: 'Remover Inspetor',
        show: canRemoverInspetor()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.INSPECAO_FINALIZADA,
        }),
        title: 'Finalizar Inspeção com Error',
        show: [Status.INSPECAO_EM_ENVIO, Status.INSPECAO_SYNC_ERROR, Status.ERRO_AO_ENVIAR_INSPECAO].includes(values.status) && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.INSPECAO_FINALIZADA,
          inspetorId: values.inspetorId,
        }),
        title: 'Finalizar Inspeção',
        show: (values.status === Status.EM_INSPECAO || values.status === Status.INSPECAO_ENVIADA_PARCIAL) && (values.inspetorId === authData.id || isAdmin())
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.AGUARDANDO_INSPECAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Reabrir Inspeção',
        show: isAdmin() && (values.status === Status.INSPECAO_FINALIZADA || values.status === Status.AGUARDANDO_DIGITACAO
          || values.status === Status.EM_DIGITACAO)
      },
      {
        onClick: () => setDigitadorModal({ open: true, isChange: false }),
        title: 'Publicar para Digitação',
        show: values.status === Status.INSPECAO_FINALIZADA && isAdmin() && isValid
      },
      {
        onClick: () => setAntecipadaModal(true),
        title: 'Liberar digitação antecipada',
        show: canShowLiberarDigitacaoAntecipada({
          authData,
          moduleConfigurations,
          status: values.status,
          tipoServicoId: values.tipoServicoId,
          digitacaoAntecipada: values.digitacaoAntecipada,
          newFlow: values.newFlow,
        }) && isValid
      },
      {
        onClick: () => setRevogarAntecipadaOpen(true),
        title: 'Revogar digitação antecipada',
        show: canShowRevogarDigitacaoAntecipada({
          authData,
          moduleConfigurations,
          status: values.status,
          tipoServicoId: values.tipoServicoId,
          digitacaoAntecipada: values.digitacaoAntecipada,
          newFlow: values.newFlow,
        })
      },
      {
        onClick: () => {
          if (isInspecaoMtBt(values.tipoServicoId)) {
            setIniciarDigitacaoModal(true);
            return;
          }
          iniciarDigitacaoNsir({
            id: values.id,
            digitadorId: authData.id,
          });
        },
        title: 'Iniciar Digitação',
        show: !isDigitacaoAntecipadaAtiva(values)
          && Status.canDigitar(values.status)
          && (values.digitadorId === authData.id || values.digitadorId === null)
      },
      {
        onClick: () => setDigitadorModal({ open: true, isChange: true }),
        title: 'Trocar Digitador',
        show: values.status === Status.AGUARDANDO_DIGITACAO && isAdmin()
      },
      {
        onClick: () => trocarDigitadorNsir({ id: values.id, digitadorId: null }),
        title: 'Remover Digitador',
        show: (values.status === Status.AGUARDANDO_DIGITACAO || values.status === Status.EM_DIGITACAO) && values.digitadorId && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.DIGITACAO_FINALIZADA,
          inspetorId: values.inspetorId,
        }, (open, message) => setDigitacaoFinalizadaError({ open, message })),
        title: 'Finalizar Digitação',
        show: values.status === Status.EM_DIGITACAO && (values.digitadorId === authData.id || isAdmin())
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.AGUARDANDO_DIGITACAO,
          inspetorId: values.inspetorId,
        }),
        title: 'Reabrir Digitação',
        show: values.status === Status.DIGITACAO_FINALIZADA && isAdmin()
      },
      {
        onClick: () => setOpenExportServico(true),
        title: 'Gerar Relatório',
        show: !!values.id
          && !isInspecaoAuditoriaFaixa(values.tipoServicoId)
          && (values.digitadorId === authData.id || isAdmin() || isUsuarioUsoMuto(authData.email))
      },
      {
        onClick: () => startRelatorioAuditoriaFaixa(values.id),
        title: 'Relatório Auditoria de Faixa',
        show: !!values.id && isAdmin() && isInspecaoAuditoriaFaixa(values.tipoServicoId)
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.EXECUTADA_GDIS,
          inspetorId: values.inspetorId,
        }),
        title: 'Concluir NSIR',
        show: values.status === Status.DIGITACAO_FINALIZADA && isAdmin()
      },
      {
        onClick: () => updateStatus({
          id: values.id,
          status: Status.FINALIZADA,
        }),
        title: 'Finalizar NSIR',
        show: values.status === Status.EXECUTADA_GDIS && isAdmin()
      },
      {
        onClick: () => setModoEdicaoAuditoriaNsir(v => !v),
        title: modoEdicaoAuditoriaNsir ? 'Encerrar auditoria' : 'Auditoria',
        show:
          !!values.id &&
          !isUsuarioUsoMuto(authData.email) &&
          isRoleAuditoriaNsir(authData.role) &&
          isInspecaoMtBt(values.tipoServicoId) &&
          situacaoPermiteEdicaoAuditoria(values.status)
      },
      {
        onClick: () => setOpenCcsm(true),
        title: 'CCSM',
        show: (values.status === Status.DIGITACAO_FINALIZADA || values.status === Status.EXECUTADA_GDIS) && isAdmin()
      },
      {
        onClick: () => setStatusModal(true),
        title: 'Reabrir NSIR',
        show: (values.status === Status.EXECUTADA_GDIS || values.status === Status.FINALIZADA) && isAdmin()
      },
      {
        onClick: () => onSaveLocal(),
        title: 'Salvar',
        show: !Status.isNsirClosed(values.status) && (
          isAdmin() || (values.status === Status.EM_INSPECAO && values.inspetorId === authData.id) || usuarioCroquiPodeEditar()
        )
      },
    ];

    return actions;
  };

  const onAddPostes = files => {
    const reader = new FileReader();

    reader.onload = e => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const excelData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: 1 }).slice(1).filter(d => d.length > 0);
      if (excelData.length === 0) {
        messageWarning({ message: 'A planilha não possui postes para serem importados!' });
        return null;
      }

      const data = excelData.map((item) => {
        return {
          municipio: item[0],
          codigo: item[2],
          numeroPoste: item[2],
          endereco: `${item[3]}, ${item[4]} - ${item[5]}`,
          rua: item[3],
          numero: item[4],
          bairro: item[5],
          latitude: item[6],
          longitude: item[7],
          fotoInicio: false,
          fotoFim: false,
          analiseRisco: false,
          fotoRegistro: false,
        };
      });
      importUsoMutuo(values.id, data, () => {
        const targetPath = `/v2/nsir/${values.id}`;
        if (location.pathname === targetPath) {
          window.location.reload();
        } else {
          history.push(targetPath);
        }
      });
    };

    reader.onerror = function() {
      messageError({ message: 'Erro ao abrir a planilha. Por favor, tente novamente!' });
    };

    reader.readAsBinaryString(files[0]);
  };

  const getSchema = data => {
    if (isUsoMutuo(data.tipoServicoId)) {
      return buildRequiredSchema(['tipoServicoId', 'clienteId', 'codigo', 'malhaId', 'km', 'possuiOficio', 'prioridade', 'newFlow', 'pausada']);
    }
    if (isInspecaoFibraOpticaOuProjetoObras(data.tipoServicoId)) {
      return buildRequiredSchema(['area', 'equipamento', 'codigo', 'malhaId', 'prioridade', 'inspecaoTermografica', 'tipoServicoId', 'clienteId']);
    }
    const baseFields = ['area', 'equipamento', 'codigo', 'malhaId', 'prioridade', 'inspecaoTermografica', 'tipoServicoId', 'clienteId'];
    if (!isInspecaoAuditoriaFaixa(data.tipoServicoId)) {
      baseFields.push('anomalia');
    }
    const schema = buildRequiredSchema(baseFields);
    let result = schema;
    if (tipoServicoTemSubtipo(data.tipoServicoId)) {
      result = {
        ...result,
        ...buildRequiredSchema(['subtipoId'])
      };
    }
    if (isInspecaoAuditoriaFaixa(data.tipoServicoId)) {
      result = {
        ...result,
        ...buildRequiredSchema(['newFlow'])
      };
    }
    return result;
  };

  const buildUsoMutuoSavePayload = (formValues) => {
    const payload = { ...formValues, equipamento: '' };
    if (!nsir?.id || isTrue(nsir?.newFlow)) {
      payload.newFlow = 'true';
    }
    return payload;
  };

  const buildAuditoriaFaixaSavePayload = (formValues) => {
    const payload = { ...formValues };
    // Criação: sempre Novo Fluxo (igual Uso Mútuo). Edição: respeita o select.
    if (!nsir?.id) {
      payload.newFlow = 'true';
    } else {
      payload.newFlow = isTrue(formValues.newFlow) ? 'true' : 'false';
    }
    return payload;
  };

  const resolveFaixaNsmps = () => {
    if (Array.isArray(nsmps) && nsmps.length > 0) return nsmps;
    if (Array.isArray(nsir?.nsmps) && nsir.nsmps.length > 0) return nsir.nsmps;
    return [];
  };

  const hasFaixaVinculos = () => {
    const hasNsmps = resolveFaixaNsmps().length > 0;
    const hasRfg = isRelatorioJobAvailable(parseRfgJob && parseRfgJob.status);
    return hasNsmps || hasRfg;
  };

  const isFaixaNewFlowUpgrade = () => (
    Boolean(values.id)
    && isInspecaoAuditoriaFaixa(values.tipoServicoId)
    && isTrue(values.newFlow)
    && !isTrue(nsir?.newFlow)
  );

  const needsFreshRfgUpload = () => (
    Boolean(values.id)
    && isInspecaoAuditoriaFaixa(values.tipoServicoId)
    && isTrue(values.newFlow)
    && (isFaixaNewFlowUpgrade() || readParseRfgFreshUpload(values.id))
  );

  const applyNewFlowValue = (nextValue) => {
    setValues((prev) => ({ ...prev, newFlow: nextValue }));
  };

  const confirmDowngradeNewFlow = () => {
    resolveFaixaNsmps().forEach((row) => {
      if (row && row.id) deleteNsmp(row.id);
    });
    cleanParseRfg();
    forgetParseRfgJobId(values.id);
    forgetParseRfgFreshUpload(values.id);
    applyNewFlowValue('false');
    setOpenDowngradeNewFlow(false);
  };

  const handleNewFlowChange = (event) => {
    const nextValue = event.target.value;
    const turningOff = isTrue(values.newFlow) && nextValue === 'false';
    const turningOnUpgrade = !isTrue(values.newFlow)
      && nextValue === 'true'
      && Boolean(values.id)
      && !isTrue(nsir?.newFlow);
    if (turningOff && hasFaixaVinculos()) {
      setOpenDowngradeNewFlow(true);
      return;
    }
    if (turningOnUpgrade) {
      cleanParseRfg();
      forgetParseRfgJobId(values.id);
      rememberParseRfgFreshUpload(values.id);
    }
    applyNewFlowValue(nextValue);
  };

  // Segurança: RFG enviado com newFlow ainda false no banco → persiste Sim (evita o reload pós-parse voltar para Não)
  useEffect(() => {
    if (!values.id || parseRfgUploadedNsirId !== values.id) return;
    if (!isInspecaoAuditoriaFaixa(values.tipoServicoId)) return;
    if (isTrue(nsir?.newFlow)) return;
    if (!isTrue(values.newFlow)) return;
    if (autoPersistNewFlowRef.current === values.id) return;
    autoPersistNewFlowRef.current = values.id;
    onSave(buildAuditoriaFaixaSavePayload({ ...values, newFlow: 'true' }));
  // eslint-disable-next-line react-hooks/exhaustive-deps -- dispara só no upload desta NSIR
  }, [parseRfgUploadedNsirId, values.id, nsir?.newFlow]);

  // Depois de salvar o Novo Fluxo no upgrade, dispara o parse do arquivo escolhido
  useEffect(() => {
    if (!isTrue(nsir?.newFlow) || !values.id) return;
    const file = pendingRfgFileRef.current;
    if (!file) return;
    pendingRfgFileRef.current = null;
    startParseRfg(values.id, file, false);
  }, [nsir?.newFlow, values.id, startParseRfg]);

  const handleSaveThenUploadRfg = (file) => {
    const currentErrors = validateRequiredFields({ ...values, newFlow: 'true' });
    if (currentErrors && Object.keys(currentErrors).length > 0) {
      messageError({
        message: 'Preencha os campos obrigatórios antes de salvar e enviar o RFG.',
      });
      return;
    }
    pendingRfgFileRef.current = file;
    rememberParseRfgFreshUpload(values.id);
    forgetParseRfgJobId(values.id);
    applyNewFlowValue('true');
    onSave(buildAuditoriaFaixaSavePayload({ ...values, newFlow: 'true' }));
  };

  const onSaveLocal = () => {
    const errors = validateRequiredFields(values);
    if (
      errors === undefined ||
      (errors &&
        Object.keys(errors).length === 0 &&
        errors.constructor === Object)
    ) {
      if (isFaixaNewFlowUpgrade()) {
        rememberParseRfgFreshUpload(values.id);
        forgetParseRfgJobId(values.id);
      }
      if (isUsoMutuo(values.tipoServicoId)) {
        onSave(buildUsoMutuoSavePayload(values));
        return;
      }
      if (isInspecaoAuditoriaFaixa(values.tipoServicoId)) {
        onSave(buildAuditoriaFaixaSavePayload(values));
        return;
      }
      onSave(values);
    }
  };

  const validateCoordenadas = data => {
    if (isInspecaoFibraOpticaOuProjetoObras(data.tipoServicoId)) {
      return {};
    }
    let currentErrors = {};

    if (data.latitude && (data.latitude.trim().length !== 9 || !data.latitude.match(/\d{2}(,\d{6})?/))) {
      currentErrors = { ...currentErrors, latitude: ['O Campo é inválido'] };
    }

    if (data.longitude && (data.longitude.trim().length !== 9 || !data.longitude.match(/\d{2}(,\d{6})?/))) {
      currentErrors = { ...currentErrors, longitude: ['O Campo é inválido'] };
    }

    return currentErrors;
  };

  const validateAdere = data => {
    if (!isInspecaoMtBt(data.tipoServicoId)) return {};

    if (isNullOrUndefined(data.possuiAdere)) {
      return { possuiAdere: ['O Campo é inválido'] };
    }

    if (isTrue(data.possuiAdere) && isNullOrUndefined(data.adereMonth)) {
      return { adereMonth: ['O Campo é inválido'] };
    }

    return {};
  };

  const validateRequiredFields = data => {
    const currentErrors = { ...validate(data, getSchema(data)), ...validateCoordenadas(data), ...validateAdere(data) };
    setErrors(currentErrors);
    return currentErrors;
  };

  return (
    <>
      {isDigitacaoAntecipadaAtiva(values) && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Inspeção ainda em andamento — digitação antecipada liberada.
          Novos postes ou serviços podem aparecer. A digitação não pode ser finalizada até a inspeção terminar.
        </Alert>
      )}
      {!values.id && isInspecaoAuditoriaFaixa(values.tipoServicoId) && isTrue(values.newFlow) && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Salve a inspeção para anexar o RFG (PDF ou Excel). O painel de upload aparece depois do primeiro salvamento.
        </Alert>
      )}
      {values.id && isInspecaoAuditoriaFaixa(values.tipoServicoId) && isTrue(values.newFlow) && (
        <Box sx={{ mb: 2 }}>
          {isFaixaNewFlowUpgrade() && (
            <Alert severity="info" sx={{ mb: 1 }}>
              Novo Fluxo ainda não está salvo. Ao enviar o RFG, vamos salvar a inspeção como Novo Fluxo e em seguida processar o arquivo.
            </Alert>
          )}
          {errors && errors.rfg && (
            <Alert severity="error" sx={{ mb: 1 }}>
              {Array.isArray(errors.rfg) ? errors.rfg[0] : errors.rfg}
            </Alert>
          )}
          <ParseRfgPanel
            nsirId={values.id}
            nsirStatus={values.status}
            canUpload={isAdmin()}
            skipHydrate={needsFreshRfgUpload()}
            requireFreshUpload={needsFreshRfgUpload()}
            needsPersistNewFlow={isFaixaNewFlowUpgrade()}
            onSaveThenUpload={handleSaveThenUploadRfg}
            rfgImportadoViaOcr={isTrue(nsir?.rfgImportadoViaOcr)}
          />
        </Box>
      )}
      <WidgetV2 title="Informações Básicas" actions={getActions()} insideTab>
        <Box sx={{ p: 2, pt: 2.5, pb: 3.75 }}>
          <Grid container spacing={1}>
            <Grid size={{ xs: 6, sm: 2 }}>
              <OptionSelectV2
                label="Tipo de Serviço"
                codigo="TIPO_SERVICO"
                isRequired
                onSelect={value => {
                  const fibraOpticaOuProjetos = isInspecaoFibraOpticaOuProjetoObras(value);
                  setValues({
                    ...values,
                    tipoServicoId: value,
                    subtipoId: null,
                    ...( (isUsoMutuo(value) || isInspecaoAuditoriaFaixa(value)) && !nsir?.id
                      ? { newFlow: 'true' }
                      : {}),
                    ...(isInspecaoAuditoriaFaixa(value) ? { anomalia: null } : {}),
                    ...(fibraOpticaOuProjetos
                      ? {
                        anomalia: null,
                        gerenciaId: null,
                        poloId: null,
                        subestacaoId: null,
                        alimentadorId: null,
                        latitude: null,
                        longitude: null,
                        situacao: null
                      }
                      : {}),
                  });
                  setErrors({});
                }}
                value={values.tipoServicoId}
                disabled={!isAdmin()}
                error={errors && errors.tipoServicoId ? true : false}
              />
            </Grid>
            {tipoServicoTemSubtipo(values.tipoServicoId) && <Grid size={{ xs: 6, sm: 2 }}>
              <OptionSelectV2
                label="Subtipo da Inspeção"
                codigo="NSIR_SUBTIPOS"
                isRequired={tipoServicoTemSubtipo(values?.tipoServicoId)}
                parentId={values.tipoServicoId}
                onSelect={value => setValues({
                  ...values,
                  subtipoId: value
                })}
                value={values.subtipoId}
                disabled={!isAdmin() || !tipoServicoTemSubtipo(values?.tipoServicoId)}
                error={errors && errors.subtipoId ? true : false}
              />
            </Grid>}
            <Grid size={{ xs: 6, sm: 2 }}>
              <OptionSelectV2
                label="Cliente"
                codigo="CLIENTE"
                isRequired
                onSelect={value => setValues({
                  ...values,
                  clienteId: value
                })}
                value={values.clienteId}
                disabled={!isAdmin()}
                error={errors && errors.clienteId ? true : false}
              />
            </Grid>
            {isUsoMutuo(values.tipoServicoId) && <Grid size={{ xs: 6, sm: 2 }}>
              <SimNaoSelectV2
                error={errors && errors.possuiOficio ? true : false}
                label="Possui Ofício"
                name="possuiOficio"
                onChange={handleChange}
                value={values.possuiOficio}
                disabled={!isAdmin()}
                isRequired
              />
            </Grid>}
            <Grid size={{ xs: 6, sm: 2 }}>
              <InputV2 label="Criado Por" disabled value={values.criadoPor} />
            </Grid>
            <Grid size={{ xs: 6, sm: 2 }}>
              <NsirStatusSelectV2 value={values.status} disabled />
            </Grid>
            <Grid size={{ xs: 6, sm: 2 }}>
              <NsirSyncStatusSelectV2 value={values.syncStatus} disabled />
            </Grid>
            {!isUsoMutuo(values.tipoServicoId) && !isInspecaoFibraOpticaOuProjetoObras(values.tipoServicoId) && (
              <InformacaoBasicaForm
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                errors={errors}
                isAdmin={isAdmin() && !Status.isNsirClosed(values.status)}
                usuarioCroquiPodeEditar={usuarioCroquiPodeEditar() && !Status.isNsirClosed(values.status)}
                podeEditarAuditoria={podeEditarAuditoriaNsir()}
                patchNsirAuditoria={patchNsirAuditoria}
                showNewFlow={isInspecaoAuditoriaFaixa(values.tipoServicoId)}
                onNewFlowChange={handleNewFlowChange}
              />
            )}
            {isInspecaoFibraOpticaOuProjetoObras(values.tipoServicoId) && (
              <ProjetoObrasFibraOpticaForm
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                errors={errors}
                isAdmin={isAdmin() && !Status.isNsirClosed(values.status)}
                usuarioCroquiPodeEditar={usuarioCroquiPodeEditar() && !Status.isNsirClosed(values.status)}
                podeEditarAuditoria={podeEditarAuditoriaNsir()}
                patchNsirAuditoria={patchNsirAuditoria}
              />
            )}
            {isUsoMutuo(values.tipoServicoId) && (
              <UsoMutuoForm
                values={values}
                setValues={setValues}
                handleChange={handleChange}
                errors={errors}
                isAdmin={isAdmin() && !Status.isNsirClosed(values.status)}
                usuarioCroquiPodeEditar={usuarioCroquiPodeEditar() && !Status.isNsirClosed(values.status)}
                persistedNewFlow={nsir?.newFlow}
                isNewNsir={!nsir?.id}
              />
            )}
            <Grid size={{ xs: 12 }}>
              <InputV2
                label="Croqui"
                name="documentoLink"
                onChange={handleChange}
                value={values.documentoLink}
                rows={2}
                multiline
                disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <InputV2
                label="Observação do Croqui"
                name="observacaoCroqui"
                onChange={handleChange}
                value={values.observacaoCroqui || ''}
                rows={2}
                multiline
                disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <InputV2
                label={isUsoMutuo(values.tipoServicoId) ? 'Observação do Lote' : 'Observação da NSIR'}
                name="observacao"
                onChange={handleChange}
                value={values.observacao}
                rows={2}
                multiline
                disabled={!isAdmin()}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <InputV2
                label="Observação do Inspetor"
                name="observacaoInspetor"
                onChange={handleChange}
                value={values.observacaoInspetor}
                rows={2}
                multiline
                disabled={!isInspetor()}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <InputV2
                label="Observação do Digitador"
                name="observacaoDigitador"
                onChange={handleChange}
                value={values.observacaoDigitador}
                rows={2}
                multiline
                disabled={!isDigitador()}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <DropzoneV2
                buttonText="Adicionar Arquivo KMZ"
                filesLimit={1}
                acceptedFiles={['.kmz', '.pdf', '.xls', '.xlsb']}
                onSave={files => {
                  if (files != null && files.length > 0) {
                    const rawFile = files[0];
                    const newName = buildNsirDocumentoKmzFileName(
                      {
                        codigo: values.codigo,
                        equipamento: values.equipamento,
                        alimentadorCodigo: values.alimentadorCodigo,
                        alimentadorId: values.alimentadorId,
                        alimentadoresOptions: alimentadoresOptions || [],
                      },
                      rawFile.name
                    );
                    const renamedFile = new File([rawFile], newName, { type: rawFile.type, lastModified: rawFile.lastModified });
                    setDocumentoKmz(renamedFile);
                    values.documentoKmzFile = renamedFile;
                    values.existDocumentoKmz = true;
                    values.documentoKmz = renamedFile.name;
                  }
                }}
                disabled={!isAdmin() && !usuarioCroquiPodeEditar()}
                showGridFiles
                files={documentoKmz != null ? [{
                  file: documentoKmz,
                  nome: documentoKmz.name,
                  onDelete: () => {
                    setDocumentoKmz(null);
                    values.documentoKmzFile = null;
                    values.existDocumentoKmz = false;
                    values.documentoKmz = null;
                    values.documentoKmzLink = null;
                  }
                }] : []}
                canDeleteFiles={isAdmin() || usuarioCroquiPodeEditar()}
              />
            </Grid>
          </Grid>
        </Box>
      </WidgetV2>
      <UsuarioModal
        grupos={[Roles.ADMIN, Roles.INSPETOR]}
        isDigitador={false}
        usuarioId={values.inspetorId}
        message={inspetorModal.isChange ? 'Alinhar com o inspetor antes de realizar a troca' : null}
        open={inspetorModal.open}
        handlerCancel={() => setInspetorModal({ open: false, isChange: false })}
        handlerConfirm={usuario => {
          setInspetorModal({ open: false, isChange: false });
          updateStatus({
            id: values.id,
            status: values.status === Status.INSPECAO_ENVIADA_PARCIAL ? Status.INSPECAO_ENVIADA_PARCIAL : Status.AGUARDANDO_INSPECAO,
            inspetorId: usuario,
            digitadorId: values.digitadorId
          });
        }}
      />
      <UsuarioModal
        grupos={[Roles.ADMIN, Roles.DIGITADOR]}
        isDigitador
        usuarioId={values.digitadorId}
        message={digitadorModal.isChange ? 'Alinhar com o digitador antes de realizar a troca' : null}
        open={digitadorModal.open}
        handlerCancel={() => setDigitadorModal({ open: false, isChange: false })}
        handlerConfirm={usuario => {
          setDigitadorModal({ open: false, isChange: false });
          trocarDigitadorNsir({ id: values.id, digitadorId: usuario });
        }}
      />
      <UsuarioModal
        grupos={[Roles.ADMIN, Roles.DIGITADOR]}
        isDigitador
        usuarioId={values.digitadorId}
        message={values.digitadorId
          ? `Digitador atual: ${values.digitadorNome || 'já vinculado'}. A inspeção continua no campo. Você pode manter este digitador ou escolher outro.`
          : 'A inspeção continua no campo. O digitador poderá trabalhar só no que já chegou.'}
        open={antecipadaModal}
        handlerCancel={() => setAntecipadaModal(false)}
        handlerConfirm={usuario => {
          setAntecipadaModal(false);
          digitacaoAntecipadaNsir({
            id: values.id,
            liberar: true,
            digitadorId: usuario,
          });
        }}
      />
      <DialogDefaultV2
        open={revogarAntecipadaOpen}
        handlerCancel={() => setRevogarAntecipadaOpen(false)}
        handlerConfirm={() => {
          digitacaoAntecipadaNsir({
            id: values.id,
            liberar: false,
            removerDigitador: false,
          });
          setRevogarAntecipadaOpen(false);
        }}
        title="Revogar digitação antecipada"
        confirmMessage="Revogar"
        cancelMessage="Cancelar"
      >
        <DialogContentText>
          O digitador deixa de poder editar enquanto a inspeção continua. O que já foi digitado permanece.
        </DialogContentText>
      </DialogDefaultV2>
      <IniciarDigitacaoModal
        open={iniciarDigitacaoModal}
        handlerCancel={() => setIniciarDigitacaoModal(false)}
        handlerConfirm={({ fotosVisualizadas, linkSistemaExterno }) => {
          setIniciarDigitacaoModal(false);
          iniciarDigitacaoNsir({
            id: values.id,
            digitadorId: authData.id,
            fotosVisualizadas,
            linkSistemaExterno,
          });
        }}
      />
      <StatusModal
        open={statusModal}
        handlerCancel={() => setStatusModal(false)}
        handlerConfirm={status => {
          setStatusModal(false);
          updateStatus({
            id: values.id,
            status: status,
            inspetorId: values.inspetorId,
            digitadorId: values.digitadorId
          });
        }}
      />
      <StatusModal
        title="Atualizar Status"
        open={atualizarStatusModal.open}
        defaultStatus={atualizarStatusModal.defaultStatus}
        handlerCancel={() => setAtualizarStatusModal({ open: false, defaultStatus: null })}
        handlerConfirm={status => {
          setAtualizarStatusModal({ open: false, defaultStatus: null });
          forceUpdateStatusNsir(values.id, status);
        }}
      />
      <DialogDefaultV2
        open={openDowngradeNewFlow}
        handlerCancel={() => setOpenDowngradeNewFlow(false)}
        handlerConfirm={confirmDowngradeNewFlow}
        title="Desligar Novo Fluxo?"
        confirmMessage="Confirmar"
        cancelMessage="Cancelar"
      >
        <DialogContentText>
          Esta NSIR está no Novo Fluxo (Sim). Ao mudar para Não, todos os serviços pré-criados
          e os vínculos do RFG serão removidos. Essa ação não pode ser desfeita facilmente.
          Deseja continuar?
        </DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={openCcsm}
        handlerCancel={() => setOpenCcsm(false)}
        handlerConfirm={() => {
          exportCcsm(values.id);
          setOpenCcsm(false);
        }}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText> Deseja exportar o relatório CCSM? </DialogContentText>
      </DialogDefaultV2>
      <ExportServicosDialog
        open={openExportServico}
        onClose={() => setOpenExportServico(false)}
        onConfirm={(apenasDigitados) => {
          generateNsirReportById({ ...values, apenasDigitados });
          setOpenExportServico(false);
        }}
        message={EXPORT_MESSAGES.SERVICO_BY_ID}
      />
      <DialogDefaultV2
        open={openRemoverInspetor}
        handlerCancel={() => setOpenRemoverInspetor(false)}
        handlerConfirm={() => {
          trocarInspetorNsir({ id: values.id, inspetorId: null });
          setOpenRemoverInspetor(false);
        }}
        title="Remover Inspetor"
        confirmMessage="Remover"
        cancelMessage="Cancelar"
      >
        <DialogContentText>
          Deseja remover o inspetor desta NSIR? O status atual será mantido.
        </DialogContentText>
      </DialogDefaultV2>
      <DialogDefaultV2
        open={digitacaoFinalizadaError.open}
        readOnly
        handlerCancel={() => setDigitacaoFinalizadaError({ open: false, message: '' })}
        handlerConfirm={() => {}}
        title="Erro"
      >
        <DialogContentText> {digitacaoFinalizadaError.message} </DialogContentText>
      </DialogDefaultV2>
      <UploadDialogV2
        onClose={() => setOpenImportPostes(false)}
        onSave={onAddPostes}
        open={openImportPostes}
        acceptedFiles={['.xls', '.xlsx']}
        dialogTitle="Importar Postes"
      />
      <SimilarityModal
        open={openSimilarityModal}
        results={similarityResults || []}
        onCancel={() => {
          setOpenSimilarityModal(false);
          clearSimilarity();
        }}
        onProceed={() => saveNsirForce(similarityPendingData, id => { history.push(`/v2/nsir/${id}`); })}
      />
    </>
  );
};

InformacaoBasicaTab.propTypes = {
  onSave: PropTypes.func.isRequired,
  onHeaderFieldsChange: PropTypes.func,
  nsir: PropTypes.object.isRequired,
  authData: PropTypes.object.isRequired,
  generateNsirReportById: PropTypes.func.isRequired,
  startRelatorioAuditoriaFaixa: PropTypes.func.isRequired,
  updateStatus: PropTypes.func.isRequired,
  iniciarDigitacaoNsir: PropTypes.func.isRequired,
  trocarDigitadorNsir: PropTypes.func.isRequired,
  trocarInspetorNsir: PropTypes.func.isRequired,
  exportCcsm: PropTypes.func.isRequired,
  alimentadoresOptions: PropTypes.array,
  patchNsirAuditoria: PropTypes.func.isRequired,
  digitacaoAntecipadaNsir: PropTypes.func.isRequired,
  nsmps: PropTypes.array,
  deleteNsmp: PropTypes.func.isRequired,
  cleanParseRfg: PropTypes.func.isRequired,
  startParseRfg: PropTypes.func.isRequired,
  parseRfgJob: PropTypes.object,
  parseRfgUploadedNsirId: PropTypes.string,
};

InformacaoBasicaTab.defaultProps = {
  alimentadoresOptions: [],
  nsmps: [],
  parseRfgJob: null,
  parseRfgUploadedNsirId: null,
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state),
  moduleConfigurations: selectorsModuleConfiguration.getModuleConfigurations(state),
  similarityResults: selectorsNsirs.getNsirSimilarityResults(state),
  similarityPendingData: selectorsNsirs.getNsirSimilarityPendingData(state),
  alimentadoresOptions: selectorsAlimentador.getAlimentadoresOptions(state),
  nsmps: selectorsNsmp.getNsmps(state),
  parseRfgJob: selectorsParseRfg.getParseRfgJob(state),
  parseRfgUploadedNsirId: selectorsParseRfg.getParseRfgUploadedNsirId(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      ...actionsNsirs,
      ...actionsToast,
      ...actionsRelatorioJob,
      ...actionsNsmp,
      ...actionsParseRfg,
      importUsoMutuo
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(InformacaoBasicaTab));
